import { FC, ReactNode, useEffect, useState } from 'react';
import { useClockContext } from '../app';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import './home.scss';

/* -------------------------------------------------------------------------------- *\
|                               HomePage
\* -------------------------------------------------------------------------------- */
export const HomePage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const clock = useClockContext();

    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true);
        setLoading(false);
        // eslint-disable-next-line
    }, [])

    return (
        <LayoutSite>
            <div className="home">
                {loading ? <Loader /> : <></>}
                <div className="home__header">
                    <div></div>
                    <div className='calendar__header__clock'>{clock}</div>
                </div>
                <div className="home__body">
                    <div className="home__body__title"><em>McLloyd</em> HPv2 simulator</div>
                </div>
            </div>
        </LayoutSite>
    );
}
